import { createContext, useState, useContext, useEffect } from 'react';

import { Button, Card, Form, Row, Col } from 'react-bootstrap';
import TextComponent from 'components/Input/TextComponent';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// 却下コメントモーダルのコンテキスト
const ApprovalRejectCommentModalContext = createContext();

/** 却下コメントモーダル */
export function ApprovalRejectCommentModalProvider({ children }) {
  // モーダルの表示
  const [show, setShow] = useState(false);

  // 却下理由
  const [rejectReason, setRejectReason] = useState('');

  // 却下コメントモーダルを開く
  const openModal = (rejectReason) => {
    setRejectReason(rejectReason);
    setShow(true);
  };

  // 却下コメントモーダルを閉じる
  const closeModal = () => {
    setShow(false);
  };

  return (
    <ApprovalRejectCommentModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <Dialog
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: '680px',
            },
          },
        }}
        open={show}
      >
        <DialogTitle className="error-modal-header p-2">却下理由</DialogTitle>
        <DialogContent className="px-0 py-0 pr-0 pl-0">
          <Card className="m-0">
            <Card.Body>
              <Row>
                <Col className="pl-2">
                  <TextComponent
                    className="form-control"
                    type="textarea"
                    rows="6"
                    readOnly={true}
                    value={rejectReason}
                  ></TextComponent>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </DialogContent>
        <DialogActions className="p-3" style={{ justifyContent: 'space-between' }}>
          <Button variant="secondary" className="footer-button" onClick={closeModal}>
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </ApprovalRejectCommentModalContext.Provider>
  );
}

export function useApprovalRejectCommentModal() {
  const context = useContext(ApprovalRejectCommentModalContext);
  if (context == undefined) {
    throw new Error('失効コメントモーダルの取得に失敗しました。');
  }
  return context;
}
